<script setup lang="ts">
import { cn } from "@/lib/utils";
import { DialogIcon } from ".";
import { useSlots } from "vue";

const slots = useSlots();

interface DialogHeaderProps {
    class?: string;
}

const props = defineProps<DialogHeaderProps>();
</script>

<template>
    <div
        :class="
            cn(
                'gap-4 space-y-2 border-iron-200 p-6 sm:text-left flex items-center border-b text-center',
                props.class,
            )
        "
    >
        <DialogIcon class="shrink-0" v-if="slots.icon">
            <slot name="icon" />
        </DialogIcon>

        <div class="gap-1 flex flex-col">
            <slot />
        </div>
    </div>
</template>
